import { makeAutoObservable } from "mobx";
import { delay } from "src/common/delay";
import { RemoteData } from "src/common/RemoteData";
import { MultiStepTaskStore } from "src/components/MultiStepTask/MultiStepTaskStore";
import { multiStepOnRowClick } from "src/components/MultiStepTask/utils";
import { EntityFiltersPageStore } from "src/pages/EntityFiltersPage/EntityFiltersPageStore";
import { ZUid } from "src/types/zUid";
import { copyMc2Entities } from "../../../apiMc2";

type ParamsMc2CopyTo = {
  modelObjectId: ZUid;
  modelEntityId: ZUid;
  mcIds: ZUid[];
  onFinish?: (needReload: boolean) => void;
};

export class Mc2CopyToStore {
  constructor() {
    makeAutoObservable(this);
  }

  taskStore = new MultiStepTaskStore();

  srcParams: ParamsMc2CopyTo = {
    modelObjectId: "",
    modelEntityId: "",
    mcIds: [],
  };

  init(params: ParamsMc2CopyTo) {
    this.srcParams = params;
    this.store1 = new EntityFiltersPageStore({
      objectId: params.modelObjectId,
      selectionSettings: { selectionType: "checkbox" },
      onRowClick: (row) => multiStepOnRowClick(row, this.store1),
      actions: new Set(), // Чтобы не было кнопки создания модели, т.к. она вызывает переход на другую страницу.
    });
    this.taskStore.open();
  }

  // --- step 1
  store1: EntityFiltersPageStore | null = null;

  get dstModelIds(): ZUid[] {
    return this.store1?.tableStore?.selected.map(({ id }) => id) ?? [];
  }

  get firstDisabled() {
    return this.dstModelIds.length === 0;
  }

  copyInfo: RemoteData<boolean> = { status: "none" };

  setCopyInfo(data: RemoteData<boolean>) {
    this.copyInfo = data;
  }

  async copy() {
    try {
      this.setCopyInfo({ status: "wait" });
      const {
        mcIds,
        modelEntityId: srcModelEntityId,
        onFinish,
      } = this.srcParams;
      const { dstModelIds } = this;

      // eslint-disable-next-line no-console
      console.log(
        `Copy points ${mcIds} from ${srcModelEntityId} to ${dstModelIds}`,
      );
      await copyMc2Entities({
        mcEntityIdsFrom: mcIds,
        modelEntityIdsTo: dstModelIds,
      });

      this.setCopyInfo({ status: "ready", result: true });
      // Перерисовка списка нужна, если среди целевых моделей есть исходная
      onFinish?.(dstModelIds.includes(srcModelEntityId));
      await delay(500); // Время для показа сообщения
      this.taskStore.close();
    } catch (error) {
      this.setCopyInfo({ status: "error", error });
    }
  }
}
